/**
 * DevExtreme (core/polyfills/promise.js)
 * Version: 17.2.18
 * Build date: Fri Dec 03 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var deferredUtils = require("../../core/utils/deferred"),
    Deferred = deferredUtils.Deferred,
    when = deferredUtils.when,
    Promise = window.Promise;
if (!Promise) {
    Promise = function(resolver) {
        var d = new Deferred;
        resolver(d.resolve.bind(this), d.reject.bind(this));
        return d.promise()
    };
    Promise.resolve = function(val) {
        return (new Deferred).resolve(val).promise()
    };
    Promise.reject = function(val) {
        return (new Deferred).reject(val).promise()
    };
    Promise.all = function(promises) {
        return when.apply(this, promises).then(function() {
            return [].slice.call(arguments)
        })
    }
}
module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/devextreme/core/polyfills/promise.js
// module id = ../../../../devextreme/core/polyfills/promise.js
// module chunks = common